module.exports = __webpack_public_path__ + "static/img/24.a90094af.png";